import { createFileRoute } from '@tanstack/react-router';

import { queryShowcases } from 'hooks/data/useShowcases';

import { ShowcaseContentView } from 'views/ShowcaseContentView';

export const Route = createFileRoute('/_auth/_layout/showcases/$id')({
  component: ShowcaseContentView,
  beforeLoad: () => {
    return {
      backTarget: '/_auth/_layout/showcases',
    };
  },
  loader: async ({ context }) => {
    context.back = {
      to: '/showcases',
    };

    return queryShowcases(context?.queryClient);
  },
});
